module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-rubo-car.8ba05e8d.jpg";